import React, { FC } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  AddSquareIcon,
  ImageCompositionIcon,
  TextIcon as HugeTextIcon,
  Download04Icon,
  Delete03Icon,
  FolderVideoIcon,
  FolderAudioIcon,
  GeometricShapes01Icon,
  MoveToIcon as MoveToHugeIcon,
  MoveIcon as MoveHugeIcon,
} from '@hugeicons/core-free-icons';

type imageProps = {
  color?: string;
  size?: string;
  hoverable?: boolean;
};

export const AiAnalysisLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 3.75002H16.2C13.8375 1.12502 9.975 1.38752 7.8 3.75002H5.25C3.7875 3.75002 2.625 4.91252 2.625 6.37502C2.625 9.15002 2.625 11.475 2.625 15.75C2.625 17.2125 3.7875 18.375 5.25 18.375H9.675C9.3375 20.0625 9.15 20.925 9.075 21.375H8.625C8.1375 21.375 8.1375 22.125 8.625 22.125C15.075 22.125 8.925 22.125 15.375 22.125C15.8625 22.125 15.8625 21.375 15.375 21.375H14.925L14.325 18.375H18.75C20.2125 18.375 21.375 17.2125 21.375 15.75C21.375 13.0125 21.375 10.5375 21.375 6.37502C21.375 4.91252 20.2125 3.75002 18.75 3.75002ZM13.575 5.92502C13.9875 6.33752 14.25 6.90002 14.25 7.50002C14.25 7.72502 14.4 7.87502 14.625 7.87502H14.9625C14.775 9.22502 13.725 10.3125 12.375 10.4625V10.125C12.375 9.90002 12.225 9.75002 12 9.75002C10.7625 9.75002 9.75 8.73752 9.75 7.50002C9.75 5.51252 12.1875 4.50002 13.575 5.92502ZM12.375 11.25C14.1375 11.0625 15.5625 9.67502 15.75 7.87502C16.9125 7.87502 16.95 7.87502 17.625 7.87502C17.4375 10.6875 15.1875 12.9375 12.375 13.125C12.375 12.45 12.375 12.375 12.375 11.25ZM14.9625 7.12502C14.8875 6.60002 14.7 6.07502 14.3625 5.66252C15.0375 4.98752 15.45 4.57502 15.7125 4.35002C16.3875 5.13752 16.8 6.11252 16.875 7.12502C15.75 7.12502 15.675 7.12502 14.9625 7.12502ZM14.175 21.375H9.825L10.425 18.375H13.575L14.175 21.375ZM20.625 15.75C20.625 16.8 19.8 17.625 18.75 17.625C13.7625 17.625 10.0875 17.625 5.25 17.625C4.2 17.625 3.375 16.8 3.375 15.75V15.375H18.75C19.2375 15.375 17.7375 14.625 17.25 14.625H3.375V6.37502C3.375 5.32502 4.2 4.50002 5.25 4.50002H7.2375C6.7125 5.32502 6.375 6.33752 6.375 7.50002C6.375 7.98752 7.125 7.98752 7.125 7.50002C7.125 6.26252 7.5375 5.21252 8.2125 4.42502C8.25 4.38752 8.25 4.38752 8.2875 4.35002C9.9375 2.47502 12.975 1.95002 15.15 3.82502C14.8875 4.08752 14.5125 4.50002 13.8375 5.17502C11.8875 3.63752 9 4.98752 9 7.50002C9 9.03752 10.1625 10.275 11.625 10.4625C11.625 11.1375 11.625 11.5875 11.625 12.3375C10.125 12.225 8.7375 11.4 7.9125 10.125C7.65 9.71252 7.0125 10.125 7.275 10.5375C8.25 12.0375 9.8625 12.975 11.625 13.125V13.5C11.625 13.725 11.775 13.875 12 13.875C15.525 13.875 18.375 11.025 18.375 7.50002C18.375 7.27502 18.225 7.12502 18 7.12502H17.625C17.55 6.18752 17.2875 5.28752 16.7625 4.50002H18.75C19.8 4.50002 20.625 5.32502 20.625 6.37502V14.625H17.25C16.7625 14.625 18.2625 15.375 18.75 15.375H20.625V15.75Z"
      fill={color}
    />
    <path
      d="M12.375 16.125H11.625C11.1375 16.125 11.1375 16.875 11.625 16.875H12.375C12.8625 16.875 12.8625 16.125 12.375 16.125Z"
      fill={color}
    />
    <path
      d="M7.31252 8.8875C7.20002 8.4 6.48752 8.5875 6.60002 9.075C6.75002 9.6375 7.53752 9.375 7.31252 8.8875Z"
      fill={color}
    />
    <path
      d="M6.37502 12.75H4.87502C4.38752 12.75 4.38752 13.5 4.87502 13.5H6.37502C6.86252 13.5 6.86252 12.75 6.37502 12.75Z"
      fill={color}
    />
    <path
      d="M6.37502 11.25H4.87502C4.38752 11.25 4.38752 12 4.87502 12H6.37502C6.86252 12 6.86252 11.25 6.37502 11.25Z"
      fill={color}
    />
  </svg>
);

export const AddTaxonomyLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2632 4.69231H18.9474V1H7.579V4.69231H13.2632ZM13.2632 4.69231V7.76923H6.06021M6.06021 7.76923H20.2106V9.61539M6.06021 7.76923V9.4917L6.31584 9.61539M6.31584 9.61539H2.52637V13.9231H10.1053V9.61539H6.31584ZM20.2106 9.61539H16.4211V13.9231H23.5V9.61539H20.2106Z"
      stroke={color}
    />
    <path
      d="M6.31574 13.9231V15.7692H3.78943M3.78943 15.7692H8.84206V17.2614M3.78943 15.7692V16.3996V17.2614"
      stroke={color}
    />
    <path
      d="M3.78938 19.4616V21.3078H1.26306M1.26306 21.3078H6.31569V23M1.26306 21.3078V22.8416"
      stroke={color}
    />
    <path
      d="M20.2105 13.9231V15.7692H17.6842M17.6842 15.7692H22.7368V17.2442M17.6842 15.7692V17.3837"
      stroke={color}
    />
    <rect
      x="16.9209"
      y="17.5"
      width="1.52632"
      height="1.46154"
      stroke={color}
    />
    <rect
      x="3.02637"
      y="17.5"
      width="1.52632"
      height="1.46154"
      stroke={color}
    />
    <rect x="0.5" y="23.0385" width="1.52632" height="1.46154" stroke={color} />
    <rect
      x="5.55273"
      y="23.0385"
      width="1.52632"
      height="1.46154"
      stroke={color}
    />
    <rect
      x="21.9736"
      y="17.5"
      width="1.52632"
      height="1.46154"
      stroke={color}
    />
    <rect x="8.0791" y="17.5" width="1.52632" height="1.46154" stroke={color} />
  </svg>
);

export const FormLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2856 2.57129H18.857C19.3117 2.57129 19.7477 2.7519 20.0692 3.07339C20.3907 3.39488 20.5713 3.83092 20.5713 4.28557V21.4284C20.5713 21.8831 20.3907 22.3191 20.0692 22.6406C19.7477 22.9621 19.3117 23.1427 18.857 23.1427H5.14275C4.6881 23.1427 4.25206 22.9621 3.93057 22.6406C3.60908 22.3191 3.42847 21.8831 3.42847 21.4284V4.28557C3.42847 3.83092 3.60908 3.39488 3.93057 3.07339C4.25206 2.7519 4.6881 2.57129 5.14275 2.57129H7.71418"
      stroke={color}
      strokeWidth="1.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5713 0.857422H9.4284C8.48162 0.857422 7.71411 1.62493 7.71411 2.57171V3.42885C7.71411 4.37562 8.48162 5.14314 9.4284 5.14314H14.5713C15.518 5.14314 16.2855 4.37562 16.2855 3.42885V2.57171C16.2855 1.62493 15.518 0.857422 14.5713 0.857422Z"
      stroke={color}
      strokeWidth="1.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71411 9.42871H16.2855"
      stroke={color}
      strokeWidth="1.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71411 13.7148H16.2855"
      stroke={color}
      strokeWidth="1.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71411 18H16.2855"
      stroke={color}
      strokeWidth="1.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewFormLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 3.13C2.5 2.36 3.36 1.5 4.12 1.5H13.88C14.64 1.5 15.5 2.36 15.5 3.13V12.88C15.5 13.64 14.64 14.5 13.88 14.5H4.13C3.36 14.5 2.5 13.64 2.5 12.88"
      stroke={color}
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5 5.5V10.5M7.5 7.5H12.5M7.5 5.5H12.5V10.5H7.5V5.5Z"
      stroke={color}
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g clip-path="url(#clip0_12870_113)">
      <path
        d="M4.22325 9.23L4.99325 10M4.75 7.875C4.75 8.37228 4.55246 8.84919 4.20083 9.20083C3.84919 9.55246 3.37228 9.75 2.875 9.75C2.37772 9.75 1.90081 9.55246 1.54917 9.20083C1.19754 8.84919 1 8.37228 1 7.875C1 7.37772 1.19754 6.90081 1.54917 6.54917C1.90081 6.19754 2.37772 6 2.875 6C3.37228 6 3.84919 6.19754 4.20083 6.54917C4.55246 6.90081 4.75 7.37772 4.75 7.875Z"
        stroke={color}
        stroke-width="0.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12870_113">
        <rect width="6" height="6" fill="white" transform="translate(0 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const AIBuilder: FC<imageProps> = ({ color }) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 1400 1400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M253.688 253.688C253.688 283.669 299.812 283.669 299.812 253.688C299.812 223.706 253.688 223.706 253.688 253.688Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M369 253.688C369 283.669 415.125 283.669 415.125 253.688C415.125 223.706 369 223.706 369 253.688Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M484.312 253.688C484.312 283.669 530.438 283.669 530.438 253.688C530.438 223.706 484.312 223.706 484.312 253.688Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M1236.15 1224.62C1215.39 1252.29 1192.33 1275.36 1162.35 1293.81C1143.9 1307.64 1153.13 1337.63 1176.19 1337.63C1199.25 1337.63 1256.91 1275.36 1273.05 1252.29C1291.5 1229.23 1254.6 1201.56 1236.15 1224.62Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M1337.62 936.337C1337.62 885.6 1293.81 846.394 1245.37 853.312V230.625C1245.37 179.887 1203.86 138.375 1153.12 138.375H853.312C823.331 138.375 1007.83 184.5 1037.81 184.5H1153.12C1178.49 184.5 1199.25 205.256 1199.25 230.625V322.875H184.5V230.625C184.5 205.256 205.256 184.5 230.625 184.5H1037.81C1067.79 184.5 883.294 138.375 853.312 138.375H230.625C179.887 138.375 138.375 179.887 138.375 230.625V622.688C138.375 652.669 184.5 595.012 184.5 565.031V369H1199.25V832.556C1171.57 804.881 1127.76 797.963 1093.16 823.331C1070.1 786.431 1026.28 774.9 991.687 793.35V668.812H1044.73C1093.16 668.812 1130.06 631.912 1130.06 588.094C1130.06 544.275 1090.86 507.375 1044.73 507.375H846.394C742.612 507.375 728.775 645.75 830.25 666.506V807.188C765.675 758.756 691.875 791.044 691.875 853.312V968.625H230.625C205.256 968.625 184.5 947.869 184.5 922.5V565.031C184.5 535.05 138.375 472.781 138.375 622.688V922.5C138.375 973.238 179.887 1014.75 230.625 1014.75H691.875V1056.26C691.875 1169.27 747.225 1273.05 841.781 1333.01C867.15 1349.16 892.519 1312.26 867.15 1293.81C786.431 1240.76 738 1153.12 738 1056.26V853.312C738 809.494 830.25 830.25 830.25 899.438V991.688C830.25 1021.67 876.375 1021.67 876.375 991.688C876.375 890.212 876.375 758.756 876.375 659.588C876.375 624.994 910.969 611.156 934.031 629.606C950.175 645.75 945.562 634.219 945.562 864.844C945.562 894.825 991.687 894.825 991.687 864.844C991.687 818.719 1060.87 816.412 1060.87 867.15V887.906C1060.87 917.887 1107 917.887 1107 887.906C1107 841.781 1176.19 839.475 1176.19 890.212V934.031C1176.19 964.012 1222.31 964.012 1222.31 934.031C1222.31 890.213 1291.5 885.6 1291.5 936.337V1053.96C1291.5 1134.68 1263.82 1148.51 1282.27 1166.96C1293.81 1178.49 1314.56 1173.88 1321.48 1157.74C1342.24 1097.78 1337.62 1056.26 1337.62 936.337ZM839.475 620.381C788.737 611.156 800.269 553.5 846.394 553.5H1044.73C1095.47 553.5 1095.47 622.688 1044.73 622.688H982.462C957.094 565.031 871.762 558.112 839.475 620.381Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M761.062 184.5C791.044 184.5 793.35 138.375 761.062 138.375C731.081 138.375 728.775 184.5 761.062 184.5Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M691.875 691.875V461.25C691.875 447.412 682.65 438.188 668.812 438.188H276.75C262.912 438.188 253.688 447.412 253.688 461.25V691.875C253.688 705.713 262.912 714.938 276.75 714.938H668.812C682.65 714.938 691.875 705.713 691.875 691.875ZM645.75 668.812H299.812V484.312H645.75V668.812Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M645.75 761.062H299.812C269.831 761.062 269.831 807.188 299.812 807.188H645.75C675.731 807.188 675.731 761.062 645.75 761.062Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
    <path
      d="M299.812 853.312C269.831 853.312 269.831 899.438 299.812 899.438H507.375C537.356 899.438 537.356 853.312 507.375 853.312H299.812Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.71"
    />
  </svg>
);

export const Quota: FC<imageProps> = ({ color }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 23.1428C18.1541 23.1428 23.1429 18.154 23.1429 12C23.1429 5.84594 18.1541 0.857117 12 0.857117C5.846 0.857117 0.857178 5.84594 0.857178 12C0.857178 18.154 5.846 23.1428 12 23.1428Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 12V18"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12.0001 8.5714C12.4735 8.5714 12.8572 8.18765 12.8572 7.71426C12.8572 7.24087 12.4735 6.85712 12.0001 6.85712C11.5267 6.85712 11.1429 7.24087 11.1429 7.71426C11.1429 8.18765 11.5267 8.5714 12.0001 8.5714Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const AnalysisLogo: FC<imageProps> = ({ color, size, hoverable }) => (
  <svg
    width={size ?? '20'}
    height={size ?? '20'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5714 23.1429L21.4285 23.1429C22.3753 23.1429 23.1428 22.3753 23.1428 21.4286L23.1428 2.57143C23.1428 1.62465 22.3753 0.85714 21.4285 0.85714L2.5714 0.85714C1.62462 0.85714 0.857109 1.62465 0.857109 2.57143L0.857109 21.4286C0.857109 22.3753 1.62462 23.1429 2.5714 23.1429Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={hoverable ? 'stroke-current' : ''}
    />
    <path
      d="M5.14282 5.14285H8.57139"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={hoverable ? 'stroke-current' : ''}
    />
    <path
      d="M5.14282 9.42857H12.8571"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={hoverable ? 'stroke-current' : ''}
    />
    <path
      d="M19.7143 9.42857L14.5714 18L8.57139 14.5714L5.14282 19.7143"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={hoverable ? 'stroke-current' : ''}
    />
  </svg>
);

export const ReportDash: FC<imageProps> = ({ color, size }) => (
  <svg
    width={size ?? '50'}
    height={size ?? '50'}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 1H24V3H2C1.44772 3 1 3.44772 1 4V34C1 34.5523 1.44772 35 2 35H7H17H18.484L13 47.795V49H15V48.205L20.659 35H24V49H26V35H29.341L35 48.205V49H37V47.795L31.516 35H48C48.5523 35 49 34.5523 49 34V4C49 3.44772 48.5523 3 48 3H26V1ZM9 33V31H15V33H9ZM47 33H17V29H7V33H3V5H47V33Z"
      fill={color}
    />
    <path
      d="M18 16.414L25 23.414L38.707 9.70697L37.293 8.29297L25 20.586L18 13.586L8.29297 23.293L9.70697 24.707L18 16.414Z"
      fill={color}
    />
    <path d="M33 23H31V29H33V23Z" fill={color} />
    <path d="M38 18H36V29H38V18Z" fill={color} />
    <path d="M43 13H41V29H43V13Z" fill={color} />
  </svg>
);

export const TransDash: FC<imageProps> = ({ color, size }) => (
  <svg
    width={size ?? '128'}
    height={size ?? '128'}
    viewBox="0 0 1400 1400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="875.5" cy="978.5" r="247.5" stroke={color} strokeWidth="50" />
    <path
      d="M1030 695.25V154.5C1030 140.841 1024.57 127.742 1014.92 118.084C1005.26 108.426 992.159 103 978.5 103H257.5C243.841 103 230.742 108.426 221.084 118.084C211.426 127.742 206 140.841 206 154.5V1081.5C206 1095.16 211.426 1108.26 221.084 1117.92C230.742 1127.57 243.841 1133 257.5 1133H540.75M437.75 309H798.25M437.75 515H798.25M437.75 721H592.25"
      stroke={color}
      strokeWidth="75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M788.594 949.531C791.155 949.531 793.611 950.549 795.422 952.36C797.233 954.17 798.25 956.627 798.25 959.188V978.5C798.25 998.988 806.389 1018.64 820.876 1033.12C835.363 1047.61 855.012 1055.75 875.5 1055.75C895.988 1055.75 915.637 1047.61 930.124 1033.12C944.611 1018.64 952.75 998.988 952.75 978.5V959.188C952.75 956.627 953.767 954.17 955.578 952.36C957.389 950.549 959.845 949.531 962.406 949.531C964.967 949.531 967.423 950.549 969.234 952.36C971.045 954.17 972.062 956.627 972.062 959.188V978.5C972.063 1002.44 963.171 1025.52 947.113 1043.28C931.055 1061.03 908.975 1072.19 885.156 1074.58V1113.69H943.094C945.655 1113.69 948.111 1114.7 949.922 1116.52C951.733 1118.33 952.75 1120.78 952.75 1123.34C952.75 1125.9 951.733 1128.36 949.922 1130.17C948.111 1131.98 945.655 1133 943.094 1133H807.906C805.345 1133 802.889 1131.98 801.078 1130.17C799.267 1128.36 798.25 1125.9 798.25 1123.34C798.25 1120.78 799.267 1118.33 801.078 1116.52C802.889 1114.7 805.345 1113.69 807.906 1113.69H865.844V1074.58C842.025 1072.19 819.945 1061.03 803.887 1043.28C787.829 1025.52 778.937 1002.44 778.938 978.5V959.188C778.938 956.627 779.955 954.17 781.766 952.36C783.577 950.549 786.033 949.531 788.594 949.531Z"
      fill={color}
    />
    <path
      d="M914.125 978.5C914.125 988.744 910.056 998.568 902.812 1005.81C895.568 1013.06 885.744 1017.12 875.5 1017.12C865.256 1017.12 855.432 1013.06 848.188 1005.81C840.944 998.568 836.875 988.744 836.875 978.5V881.938C836.875 871.694 840.944 861.869 848.188 854.626C855.432 847.382 865.256 843.312 875.5 843.312C885.744 843.312 895.568 847.382 902.812 854.626C910.056 861.869 914.125 871.694 914.125 881.938V978.5ZM875.5 824C860.134 824 845.397 830.104 834.532 840.97C823.667 851.835 817.562 866.572 817.562 881.938V978.5C817.562 993.866 823.667 1008.6 834.532 1019.47C845.397 1030.33 860.134 1036.44 875.5 1036.44C890.866 1036.44 905.603 1030.33 916.468 1019.47C927.333 1008.6 933.438 993.866 933.438 978.5V881.938C933.438 866.572 927.333 851.835 916.468 840.97C905.603 830.104 890.866 824 875.5 824V824Z"
      fill={color}
    />
  </svg>
);

export const ViewTranscriptIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17"
      cy="19"
      r="4.75"
      className="stroke-current"
      stroke-width="0.5"
    />
    <path
      d="M20 13.5V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22H10.5M8.5 6H15.5M8.5 10H15.5M8.5 14H11.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="stroke-current"
    />
    <path
      d="M15.3125 18.4375C15.3622 18.4375 15.4099 18.4573 15.4451 18.4924C15.4802 18.5276 15.5 18.5753 15.5 18.625V19C15.5 19.3978 15.658 19.7794 15.9393 20.0607C16.2206 20.342 16.6022 20.5 17 20.5C17.3978 20.5 17.7794 20.342 18.0607 20.0607C18.342 19.7794 18.5 19.3978 18.5 19V18.625C18.5 18.5753 18.5198 18.5276 18.5549 18.4924C18.5901 18.4573 18.6378 18.4375 18.6875 18.4375C18.7372 18.4375 18.7849 18.4573 18.8201 18.4924C18.8552 18.5276 18.875 18.5753 18.875 18.625V19C18.875 19.4648 18.7024 19.9131 18.3905 20.2578C18.0787 20.6025 17.65 20.8191 17.1875 20.8656V21.625H18.3125C18.3622 21.625 18.4099 21.6448 18.4451 21.6799C18.4802 21.7151 18.5 21.7628 18.5 21.8125C18.5 21.8622 18.4802 21.9099 18.4451 21.9451C18.4099 21.9802 18.3622 22 18.3125 22H15.6875C15.6378 22 15.5901 21.9802 15.5549 21.9451C15.5198 21.9099 15.5 21.8622 15.5 21.8125C15.5 21.7628 15.5198 21.7151 15.5549 21.6799C15.5901 21.6448 15.6378 21.625 15.6875 21.625H16.8125V20.8656C16.35 20.8191 15.9213 20.6025 15.6095 20.2578C15.2976 19.9131 15.125 19.4648 15.125 19V18.625C15.125 18.5753 15.1448 18.5276 15.1799 18.4924C15.2151 18.4573 15.2628 18.4375 15.3125 18.4375Z"
      className="fill-current"
    />
    <path
      d="M17.75 19C17.75 19.1989 17.671 19.3897 17.5303 19.5303C17.3897 19.671 17.1989 19.75 17 19.75C16.8011 19.75 16.6103 19.671 16.4697 19.5303C16.329 19.3897 16.25 19.1989 16.25 19V17.125C16.25 16.9261 16.329 16.7353 16.4697 16.5947C16.6103 16.454 16.8011 16.375 17 16.375C17.1989 16.375 17.3897 16.454 17.5303 16.5947C17.671 16.7353 17.75 16.9261 17.75 17.125V19ZM17 16C16.7016 16 16.4155 16.1185 16.2045 16.3295C15.9935 16.5405 15.875 16.8266 15.875 17.125V19C15.875 19.2984 15.9935 19.5845 16.2045 19.7955C16.4155 20.0065 16.7016 20.125 17 20.125C17.2984 20.125 17.5845 20.0065 17.7955 19.7955C18.0065 19.5845 18.125 19.2984 18.125 19V17.125C18.125 16.8266 18.0065 16.5405 17.7955 16.3295C17.5845 16.1185 17.2984 16 17 16V16Z"
      className="fill-current"
    />
  </svg>
);

export const CrossLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 20L4 4M20 4L4 20"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const FilterLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2863 0.714287H0.714844C0.715633 2.80509 1.42093 4.83463 2.71691 6.47534C4.01288 8.11604 5.82392 9.27218 7.8577 9.75714V19.2857L12.1434 16.4286V9.75714C14.1772 9.27218 15.9882 8.11604 17.2842 6.47534C18.5802 4.83463 19.2855 2.80509 19.2863 0.714287V0.714287Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarGraphLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.857422 23.1428H23.1431"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71456 23.1429V0.857178H0.857422V23.1429"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.572 23.1428V11.1428H7.71484V23.1428"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4294 23.1429V6H14.5723V23.1429"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GaugeGraphLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1134_4706)">
      <path
        d="M17.1429 11.1436L12 19.715"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.286 19.7147C22.9915 18.0214 23.2681 16.1801 23.0912 14.3542C22.9142 12.5283 22.2893 10.7744 21.2717 9.24804C20.2541 7.72171 18.8755 6.4702 17.2581 5.60462C15.6408 4.73903 13.8347 4.28613 12.0003 4.28613C10.1659 4.28613 8.3598 4.73903 6.74244 5.60462C5.12507 6.4702 3.74642 7.72171 2.72886 9.24804C1.71131 10.7744 1.08632 12.5283 0.909381 14.3542C0.73244 16.1801 1.00902 18.0214 1.71457 19.7147H22.286Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1134_4706">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PieGraphLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0003 23.1429C18.1543 23.1429 23.1431 18.1541 23.1431 12C23.1431 5.846 18.1543 0.857178 12.0003 0.857178C5.84625 0.857178 0.857422 5.846 0.857422 12C0.857422 18.1541 5.84625 23.1429 12.0003 23.1429Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 0.857178V12L19.8857 19.8858"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon: FC<imageProps> = ({ color, size = 20 }) => (
  <HugeiconsIcon
    icon={Delete03Icon}
    size={size}
    color={color || '#242424'}
    strokeWidth={1.5}
  />
);

export const RenameIcon: FC<imageProps> = ({ color, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 2C8.36739 2 8.24021 2.05268 8.14645 2.14645C8.05268 2.24021 8 2.36739 8 2.5C8 2.63261 8.05268 2.75979 8.14645 2.85355C8.24021 2.94732 8.36739 3 8.5 3H9.5V17H8.5C8.36739 17 8.24021 17.0527 8.14645 17.1464C8.05268 17.2402 8 17.3674 8 17.5C8 17.6326 8.05268 17.7598 8.14645 17.8536C8.24021 17.9473 8.36739 18 8.5 18H11.5C11.6326 18 11.7598 17.9473 11.8536 17.8536C11.9473 17.7598 12 17.6326 12 17.5C12 17.3674 11.9473 17.2402 11.8536 17.1464C11.7598 17.0527 11.6326 17 11.5 17H10.5V3H11.5C11.6326 3 11.7598 2.94732 11.8536 2.85355C11.9473 2.75979 12 2.63261 12 2.5C12 2.36739 11.9473 2.24021 11.8536 2.14645C11.7598 2.05268 11.6326 2 11.5 2H8.5ZM4.5 4H8.5V5H4.5C4.10218 5 3.72064 5.15804 3.43934 5.43934C3.15804 5.72064 3 6.10218 3 6.5V13.5C3 13.8978 3.15804 14.2794 3.43934 14.5607C3.72064 14.842 4.10218 15 4.5 15H8.5V16H4.5C3.83696 16 3.20107 15.7366 2.73223 15.2678C2.26339 14.7989 2 14.163 2 13.5V6.5C2 5.83696 2.26339 5.20107 2.73223 4.73223C3.20107 4.26339 3.83696 4 4.5 4ZM15.5 15H11.5V16H15.5C16.163 16 16.7989 15.7366 17.2678 15.2678C17.7366 14.7989 18 14.163 18 13.5V6.5C18 5.83696 17.7366 5.20107 17.2678 4.73223C16.7989 4.26339 16.163 4 15.5 4H11.5V5H15.5C15.8978 5 16.2794 5.15804 16.5607 5.43934C16.842 5.72064 17 6.10218 17 6.5V13.5C17 13.8978 16.842 14.2794 16.5607 14.5607C16.2794 14.842 15.8978 15 15.5 15Z"
      fill={color}
    />
  </svg>
);

export const SimpleDeleteIcon: FC<imageProps> = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99967 12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V4.66667H3.99967V12.6667ZM5.33301 6H10.6663V12.6667H5.33301V6ZM10.333 2.66667L9.66634 2H6.33301L5.66634 2.66667H3.33301V4H12.6663V2.66667H10.333Z"
      fill="#242424"
    />
  </svg>
);

export const SimpleBigDeleteIcon: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 18.5455C6 19.6121 6.9 20 8 20H16C17.1 20 18 19.6121 18 18.5455V6.90909H6V18.5455ZM7 7.87879H17V19.0303H7V7.87879ZM15 4.9697L14 4H9.5L8.5 4.9697H5V5.93939H19V4.9697H15Z"
      fill="#242424"
    />
  </svg>
);

export const SimpleEditIcon: FC<imageProps> = ({ color }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46266 12.8883L3 13.8574L3.96954 10.3961L10.3101 4.08885C10.3817 4.01559 10.4673 3.95738 10.5618 3.91764C10.6563 3.87789 10.7577 3.85742 10.8602 3.85742C10.9627 3.85742 11.0642 3.87789 11.1587 3.91764C11.2532 3.95738 11.3387 4.01559 11.4104 4.08885L12.7724 5.45799C12.8445 5.52949 12.9018 5.61456 12.9408 5.7083C12.9799 5.80203 13 5.90256 13 6.0041C13 6.10565 12.9799 6.20618 12.9408 6.29991C12.9018 6.39364 12.8445 6.47872 12.7724 6.55022L6.46266 12.8883Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReelLogo: FC<imageProps> = ({ color = '#242424', size }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
      stroke={color}
      stroke-linejoin="round"
    />
    <path
      d="M12 9C12.3978 9 12.7794 8.84196 13.0607 8.56066C13.342 8.27936 13.5 7.89782 13.5 7.5C13.5 7.10218 13.342 6.72064 13.0607 6.43934C12.7794 6.15804 12.3978 6 12 6C11.6022 6 11.2206 6.15804 10.9393 6.43934C10.658 6.72064 10.5 7.10218 10.5 7.5C10.5 7.89782 10.658 8.27936 10.9393 8.56066C11.2206 8.84196 11.6022 9 12 9ZM12 18C12.3978 18 12.7794 17.842 13.0607 17.5607C13.342 17.2794 13.5 16.8978 13.5 16.5C13.5 16.1022 13.342 15.7206 13.0607 15.4393C12.7794 15.158 12.3978 15 12 15C11.6022 15 11.2206 15.158 10.9393 15.4393C10.658 15.7206 10.5 16.1022 10.5 16.5C10.5 16.8978 10.658 17.2794 10.9393 17.5607C11.2206 17.842 11.6022 18 12 18ZM7.5 13.5C7.89782 13.5 8.27936 13.342 8.56066 13.0607C8.84196 12.7794 9 12.3978 9 12C9 11.6022 8.84196 11.2206 8.56066 10.9393C8.27936 10.658 7.89782 10.5 7.5 10.5C7.10218 10.5 6.72064 10.658 6.43934 10.9393C6.15804 11.2206 6 11.6022 6 12C6 12.3978 6.15804 12.7794 6.43934 13.0607C6.72064 13.342 7.10218 13.5 7.5 13.5V13.5ZM16.5 13.5C16.8978 13.5 17.2794 13.342 17.5607 13.0607C17.842 12.7794 18 12.3978 18 12C18 11.6022 17.842 11.2206 17.5607 10.9393C17.2794 10.658 16.8978 10.5 16.5 10.5C16.1022 10.5 15.7206 10.658 15.4393 10.9393C15.158 11.2206 15 11.6022 15 12C15 12.3978 15.158 12.7794 15.4393 13.0607C15.7206 13.342 16.1022 13.5 16.5 13.5Z"
      stroke={color}
      stroke-linejoin="round"
    />
    <path d="M12 22H22" stroke={color} stroke-linecap="round" />
  </svg>
);

export const TableLogo: FC<imageProps> = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1818 2H3.81818C2.81403 2 2 2.68879 2 3.53846V20.4615C2 21.3112 2.81403 22 3.81818 22H20.1818C21.186 22 22 21.3112 22 20.4615V3.53846C22 2.68879 21.186 2 20.1818 2Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7168 6.87378H16.2882"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7168 11.9163H16.2882"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7168 16.9583H12.8597"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type EnumerateLogoType = {
  withName?: Boolean;
};
export const EnumerateLogo: FC<EnumerateLogoType> = ({ withName = true }) => (
  <svg
    width="150"
    height="40"
    viewBox="0 0 231 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {withName && (
      <>
        {' '}
        <path
          d="M85.848 33V16.08H97.104V18.528H88.8V23.184H96.576V25.632H88.8V30.552H97.104V33H85.848ZM99.8803 33V21.264H102.808V23.088C103.208 22.416 103.744 21.904 104.416 21.552C105.104 21.2 105.872 21.024 106.72 21.024C109.488 21.024 110.872 22.632 110.872 25.848V33H107.872V25.992C107.872 25.08 107.696 24.416 107.344 24C107.008 23.584 106.48 23.376 105.76 23.376C104.88 23.376 104.176 23.656 103.648 24.216C103.136 24.76 102.88 25.488 102.88 26.4V33H99.8803ZM118.167 33.24C115.287 33.24 113.847 31.624 113.847 28.392V21.264H116.847V28.44C116.847 29.272 117.015 29.888 117.351 30.288C117.687 30.688 118.223 30.888 118.959 30.888C119.759 30.888 120.415 30.616 120.927 30.072C121.439 29.512 121.695 28.776 121.695 27.864V21.264H124.695V33H121.767V31.248C120.983 32.576 119.783 33.24 118.167 33.24ZM127.866 33V21.264H130.794V23.064C131.146 22.424 131.634 21.928 132.258 21.576C132.882 21.208 133.602 21.024 134.418 21.024C136.178 21.024 137.33 21.792 137.874 23.328C138.242 22.608 138.77 22.048 139.458 21.648C140.146 21.232 140.93 21.024 141.81 21.024C144.45 21.024 145.77 22.632 145.77 25.848V33H142.77V25.968C142.77 25.072 142.618 24.416 142.314 24C142.026 23.584 141.53 23.376 140.826 23.376C140.042 23.376 139.426 23.656 138.978 24.216C138.53 24.76 138.306 25.52 138.306 26.496V33H135.306V25.968C135.306 25.072 135.154 24.416 134.85 24C134.562 23.584 134.074 23.376 133.386 23.376C132.602 23.376 131.986 23.656 131.538 24.216C131.09 24.76 130.866 25.52 130.866 26.496V33H127.866ZM154.649 33.24C153.321 33.24 152.177 32.992 151.217 32.496C150.257 32 149.513 31.296 148.985 30.384C148.473 29.472 148.217 28.392 148.217 27.144C148.217 25.928 148.465 24.864 148.961 23.952C149.473 23.04 150.169 22.328 151.049 21.816C151.945 21.288 152.961 21.024 154.097 21.024C155.761 21.024 157.073 21.552 158.033 22.608C159.009 23.664 159.497 25.104 159.497 26.928V27.816H151.097C151.321 29.912 152.521 30.96 154.697 30.96C155.353 30.96 156.009 30.864 156.665 30.672C157.321 30.464 157.921 30.144 158.465 29.712L159.305 31.728C158.745 32.192 158.041 32.56 157.193 32.832C156.345 33.104 155.497 33.24 154.649 33.24ZM154.217 23.064C153.337 23.064 152.625 23.336 152.081 23.88C151.537 24.424 151.209 25.16 151.097 26.088H157.001C156.937 25.112 156.665 24.368 156.185 23.856C155.721 23.328 155.065 23.064 154.217 23.064ZM161.873 33V21.264H164.801V23.328C165.377 21.936 166.609 21.168 168.497 21.024L169.409 20.952L169.601 23.496L167.873 23.664C165.905 23.856 164.921 24.864 164.921 26.688V33H161.873ZM175.018 33.24C174.17 33.24 173.41 33.08 172.738 32.76C172.082 32.424 171.562 31.976 171.178 31.416C170.81 30.856 170.626 30.224 170.626 29.52C170.626 28.656 170.85 27.976 171.298 27.48C171.746 26.968 172.474 26.6 173.482 26.376C174.49 26.152 175.842 26.04 177.538 26.04H178.378V25.536C178.378 24.736 178.202 24.16 177.85 23.808C177.498 23.456 176.906 23.28 176.074 23.28C175.418 23.28 174.746 23.384 174.058 23.592C173.37 23.784 172.674 24.088 171.97 24.504L171.106 22.464C171.522 22.176 172.01 21.928 172.57 21.72C173.146 21.496 173.746 21.328 174.37 21.216C175.01 21.088 175.61 21.024 176.17 21.024C177.882 21.024 179.154 21.424 179.986 22.224C180.818 23.008 181.234 24.232 181.234 25.896V33H178.426V31.128C178.154 31.784 177.722 32.304 177.13 32.688C176.538 33.056 175.834 33.24 175.018 33.24ZM175.642 31.176C176.426 31.176 177.074 30.904 177.586 30.36C178.114 29.816 178.378 29.128 178.378 28.296V27.768H177.562C176.058 27.768 175.01 27.888 174.418 28.128C173.842 28.352 173.554 28.768 173.554 29.376C173.554 29.904 173.738 30.336 174.106 30.672C174.474 31.008 174.986 31.176 175.642 31.176ZM189.655 33.24C186.551 33.24 184.999 31.704 184.999 28.632V23.52H182.743V21.264H184.999V17.76H187.999V21.264H191.551V23.52H187.999V28.464C187.999 29.232 188.167 29.808 188.503 30.192C188.839 30.576 189.383 30.768 190.135 30.768C190.359 30.768 190.591 30.744 190.831 30.696C191.071 30.632 191.319 30.568 191.575 30.504L192.031 32.712C191.743 32.872 191.375 33 190.927 33.096C190.495 33.192 190.071 33.24 189.655 33.24ZM199.157 33.24C197.829 33.24 196.685 32.992 195.725 32.496C194.765 32 194.021 31.296 193.493 30.384C192.981 29.472 192.725 28.392 192.725 27.144C192.725 25.928 192.973 24.864 193.469 23.952C193.981 23.04 194.677 22.328 195.557 21.816C196.453 21.288 197.469 21.024 198.605 21.024C200.269 21.024 201.581 21.552 202.541 22.608C203.517 23.664 204.005 25.104 204.005 26.928V27.816H195.605C195.829 29.912 197.029 30.96 199.205 30.96C199.861 30.96 200.517 30.864 201.173 30.672C201.829 30.464 202.429 30.144 202.973 29.712L203.812 31.728C203.253 32.192 202.549 32.56 201.701 32.832C200.853 33.104 200.005 33.24 199.157 33.24ZM198.725 23.064C197.845 23.064 197.133 23.336 196.589 23.88C196.045 24.424 195.717 25.16 195.605 26.088H201.509C201.445 25.112 201.173 24.368 200.693 23.856C200.229 23.328 199.573 23.064 198.725 23.064ZM216.197 33.24C215.349 33.24 214.589 33.08 213.917 32.76C213.261 32.424 212.741 31.976 212.357 31.416C211.989 30.856 211.805 30.224 211.805 29.52C211.805 28.656 212.029 27.976 212.477 27.48C212.925 26.968 213.653 26.6 214.661 26.376C215.669 26.152 217.021 26.04 218.717 26.04H219.557V25.536C219.557 24.736 219.381 24.16 219.029 23.808C218.677 23.456 218.085 23.28 217.253 23.28C216.597 23.28 215.925 23.384 215.237 23.592C214.549 23.784 213.853 24.088 213.149 24.504L212.285 22.464C212.701 22.176 213.189 21.928 213.749 21.72C214.325 21.496 214.925 21.328 215.549 21.216C216.189 21.088 216.789 21.024 217.349 21.024C219.061 21.024 220.333 21.424 221.165 22.224C221.997 23.008 222.413 24.232 222.413 25.896V33H219.605V31.128C219.333 31.784 218.901 32.304 218.309 32.688C217.717 33.056 217.013 33.24 216.197 33.24ZM216.821 31.176C217.605 31.176 218.253 30.904 218.765 30.36C219.293 29.816 219.557 29.128 219.557 28.296V27.768H218.741C217.237 27.768 216.189 27.888 215.597 28.128C215.021 28.352 214.733 28.768 214.733 29.376C214.733 29.904 214.917 30.336 215.285 30.672C215.653 31.008 216.165 31.176 216.821 31.176ZM225.266 18.744V15.816H228.626V18.744H225.266ZM225.458 33V21.264H228.458V33H225.458Z"
          fill="#242424"
        />
        <path d="M206.116 33V29.664H209.476V33H206.116Z" fill="#CD74EA" />{' '}
      </>
    )}
    <rect
      x="21.7034"
      y="25.1484"
      width="35.5651"
      height="35.5651"
      transform="rotate(-45 21.7034 25.1484)"
      fill="url(#paint0_linear_456_1076)"
    />
    <rect
      y="25.1484"
      width="35.5651"
      height="35.5651"
      transform="rotate(-45 0 25.1484)"
      fill="url(#paint1_linear_456_1076)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_456_1076"
        x1="16.2833"
        y1="19.7284"
        x2="74.442"
        y2="77.8871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9051A4" />
        <stop offset="0.118021" stopColor="#CD74EA" />
        <stop offset="0.241612" stopColor="#CD74EA" />
        <stop offset="0.744599" stopColor="#DC9EF0" />
        <stop offset="1" stopColor="#DC9EF0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_456_1076"
        x1="-31.1195"
        y1="-5.97103"
        x2="47.7449"
        y2="72.8934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3B55A9" />
        <stop offset="0.118021" stopColor="#5579F2" />
        <stop offset="0.197917" stopColor="#5579F2" />
        <stop offset="0.744599" stopColor="#7A93E8" />
        <stop offset="1" stopColor="#88A1F6" />
      </linearGradient>
    </defs>
  </svg>
);

export const PlayReelLogo: FC<any> = ({ size }) => (
  <svg
    width={size ?? '20'}
    height={size ?? '20'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16.5L16 12L10 7.5M22 12C22 6.46 17.54 2 12 2C10.83 2 9.7 2.19 8.62 2.56L9.32 4.5C10.17 4.16 11.06 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 11.06 4.16 10.12 4.5 9.28L2.56 8.62C2.19 9.7 2 10.83 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12ZM5.47 3.97C6.32 3.97 7 4.68 7 5.47C7 6.32 6.32 7 5.47 7C4.68 7 3.97 6.32 3.97 5.47C3.97 4.68 4.68 3.97 5.47 3.97Z"
      fill="#242424"
    />
  </svg>
);

export const CreateThemeLogo: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2613_3856)">
      <path
        d="M22.1071 12.7531L13.0537 3.69978C12.9332 3.58142 12.7905 3.48809 12.6337 3.42516C12.477 3.36223 12.3093 3.33094 12.1404 3.33311H10.7471L21.1671 13.6331L14.1471 20.7131C14.2666 20.8326 14.4084 20.9275 14.5646 20.9922C14.7207 21.0569 14.8881 21.0902 15.0571 21.0902C15.2261 21.0902 15.3934 21.0569 15.5496 20.9922C15.7057 20.9275 15.8476 20.8326 15.9671 20.7131L22.1071 14.5731C22.2266 14.4536 22.3214 14.3118 22.3861 14.1556C22.4508 13.9995 22.4841 13.8321 22.4841 13.6631C22.4841 13.4941 22.4508 13.3267 22.3861 13.1706C22.3214 13.0145 22.2266 12.8726 22.1071 12.7531Z"
        fill="#242424"
      />
      <path
        d="M5.20698 8.31337C5.69667 8.31337 6.09365 7.9164 6.09365 7.42671C6.09365 6.93701 5.69667 6.54004 5.20698 6.54004C4.71729 6.54004 4.32031 6.93701 4.32031 7.42671C4.32031 7.9164 4.71729 8.31337 5.20698 8.31337Z"
        fill="#242424"
      />
      <path
        d="M18.5201 12.7797L9.46678 3.71967C9.34792 3.5977 9.20592 3.50068 9.04909 3.43428C8.89226 3.36789 8.72376 3.33346 8.55345 3.33301H2.40678C2.06554 3.33301 1.73827 3.46857 1.49697 3.70986C1.25568 3.95116 1.12012 4.27843 1.12012 4.61967V10.7663C1.12058 10.9351 1.15439 11.102 1.2196 11.2576C1.28482 11.4132 1.38015 11.5544 1.50012 11.673L10.5601 20.733C10.6796 20.8525 10.8215 20.9474 10.9776 21.0121C11.1337 21.0768 11.3011 21.1101 11.4701 21.1101C11.6391 21.1101 11.8065 21.0768 11.9626 21.0121C12.1188 20.9474 12.2606 20.8525 12.3801 20.733L18.5201 14.593C18.7595 14.352 18.8938 14.026 18.8938 13.6863C18.8938 13.3466 18.7595 13.0207 18.5201 12.7797ZM11.5068 19.793L2.46012 10.7663V4.66634H8.52678L17.5801 13.653L11.5068 19.793Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_2613_3856">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ReelSmallLogo: FC<imageProps> = ({ color = '#242424' }) => (
  <div className="h-5">
    <svg
      width="50"
      height="45"
      viewBox="0 0 61 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={1.5}
    >
      <path
        d="M30 22C35.523 22 40 17.523 40 12C40 6.477 35.523 2 30 2C24.477 2 20 6.477 20 12C20 17.523 24.477 22 30 22Z"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        d="M30 9C30.3978 9 30.7794 8.84196 31.0607 8.56066C31.342 8.27936 31.5 7.89782 31.5 7.5C31.5 7.10218 31.342 6.72064 31.0607 6.43934C30.7794 6.15804 30.3978 6 30 6C29.6022 6 29.2206 6.15804 28.9393 6.43934C28.658 6.72064 28.5 7.10218 28.5 7.5C28.5 7.89782 28.658 8.27936 28.9393 8.56066C29.2206 8.84196 29.6022 9 30 9ZM30 18C30.3978 18 30.7794 17.842 31.0607 17.5607C31.342 17.2794 31.5 16.8978 31.5 16.5C31.5 16.1022 31.342 15.7206 31.0607 15.4393C30.7794 15.158 30.3978 15 30 15C29.6022 15 29.2206 15.158 28.9393 15.4393C28.658 15.7206 28.5 16.1022 28.5 16.5C28.5 16.8978 28.658 17.2794 28.9393 17.5607C29.2206 17.842 29.6022 18 30 18ZM25.5 13.5C25.8978 13.5 26.2794 13.342 26.5607 13.0607C26.842 12.7794 27 12.3978 27 12C27 11.6022 26.842 11.2206 26.5607 10.9393C26.2794 10.658 25.8978 10.5 25.5 10.5C25.1022 10.5 24.7206 10.658 24.4393 10.9393C24.158 11.2206 24 11.6022 24 12C24 12.3978 24.158 12.7794 24.4393 13.0607C24.7206 13.342 25.1022 13.5 25.5 13.5V13.5ZM34.5 13.5C34.8978 13.5 35.2794 13.342 35.5607 13.0607C35.842 12.7794 36 12.3978 36 12C36 11.6022 35.842 11.2206 35.5607 10.9393C35.2794 10.658 34.8978 10.5 34.5 10.5C34.1022 10.5 33.7206 10.658 33.4393 10.9393C33.158 11.2206 33 11.6022 33 12C33 12.3978 33.158 12.7794 33.4393 13.0607C33.7206 13.342 34.1022 13.5 34.5 13.5Z"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M30 22H40" stroke={color} strokeLinecap="round" />
    </svg>
  </div>
);

export const PlayIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.5 20C37.501 20.4245 37.3922 20.8419 37.1841 21.2118C36.976 21.5817 36.6758 21.8915 36.3125 22.111L13.8 35.8829C13.4204 36.1153 12.9857 36.2422 12.5407 36.2504C12.0958 36.2586 11.6566 36.1479 11.2688 35.9297C10.8845 35.7149 10.5645 35.4016 10.3415 35.0221C10.1185 34.6426 10.0006 34.2105 10 33.7704V6.22973C10.0006 5.78956 10.1185 5.35749 10.3415 4.97797C10.5645 4.59845 10.8845 4.28518 11.2688 4.07036C11.6566 3.85215 12.0958 3.74146 12.5407 3.7497C12.9857 3.75794 13.4204 3.88482 13.8 4.11724L36.3125 17.8891C36.6758 18.1086 36.976 18.4184 37.1841 18.7883C37.3922 19.1582 37.501 19.5756 37.5 20Z"
      fill="white"
    />
  </svg>
);

export const VideoIcon = ({ color, small, size }: any) => (
  <HugeiconsIcon
    strokeWidth={1}
    icon={FolderVideoIcon}
    size={size || (small ? 24 : 37.5)}
    color={color}
  />
);

export const AudioIcon = ({ color, small, size }: any) => (
  <HugeiconsIcon
    icon={FolderAudioIcon}
    size={size || (small ? 24 : 37.5)}
    color={color}
    strokeWidth={1}
  />
);

export const ImageIcon = ({ color, small, size }: any) => (
  <HugeiconsIcon
    icon={ImageCompositionIcon}
    size={size || (small ? 24 : 37.5)}
    color={color}
    strokeWidth={1}
  />
);

export const DownloadIcon = ({ color, size }: any) => (
  <HugeiconsIcon
    icon={Download04Icon}
    size={size || 37.5}
    color={color}
    strokeWidth={1}
  />
);

export const ElementIcon = ({ color, size }: any) => (
  <HugeiconsIcon
    icon={GeometricShapes01Icon}
    size={size || 24}
    color={color}
    strokeWidth={1}
  />
);

export const TextIcon = ({ color, size }: any) => (
  <HugeiconsIcon
    strokeWidth={1}
    icon={HugeTextIcon}
    size={size || 37.5}
    color={color}
  />
);

export const UploadIcon: FC<imageProps> = ({ color }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3125 22.5C5.6025 22.5 4.14375 21.9113 2.93625 20.7338C1.72875 19.5488 1.125 18.105 1.125 16.4025C1.125 14.94 1.56375 13.635 2.44125 12.4875C3.32625 11.34 4.48125 10.6087 5.90625 10.2937C6.37875 8.56875 7.31625 7.17375 8.71875 6.10875C10.1287 5.03625 11.7225 4.5 13.5 4.5C15.6975 4.5 17.5575 5.265 19.08 6.795C20.61 8.3175 21.375 10.1775 21.375 12.375C22.6725 12.525 23.745 13.0875 24.5925 14.0625C25.4475 15.0225 25.875 16.1475 25.875 17.4375C25.875 18.8475 25.3838 20.0438 24.4013 21.0263C23.4188 22.0088 22.2225 22.5 20.8125 22.5H14.625C14.01 22.5 13.4813 22.2787 13.0388 21.8363C12.5963 21.4013 12.375 20.8725 12.375 20.25V14.4563L10.575 16.2L9 14.625L13.5 10.125L18 14.625L16.425 16.2L14.625 14.4563V20.25H20.8125C21.6 20.25 22.2638 19.9763 22.8038 19.4288C23.3513 18.8888 23.625 18.225 23.625 17.4375C23.625 16.65 23.3513 15.9862 22.8038 15.4462C22.2638 14.8988 21.6 14.625 20.8125 14.625H19.125V12.375C19.125 10.8225 18.5775 9.495 17.4825 8.3925C16.3875 7.2975 15.06 6.75 13.5 6.75C11.9475 6.75 10.62 7.2975 9.5175 8.3925C8.4225 9.495 7.875 10.8225 7.875 12.375H7.3125C6.225 12.375 5.29875 12.7613 4.53375 13.5338C3.76125 14.2987 3.375 15.225 3.375 16.3125C3.375 17.4 3.76125 18.3375 4.53375 19.125C5.29875 19.875 6.225 20.25 7.3125 20.25H10.125V22.5"
      fill={color || '#242424'}
    />
  </svg>
);

export const PlusIcon: FC<imageProps> = ({ color }) => (
  <HugeiconsIcon
    icon={AddSquareIcon}
    size={24}
    color={color || '#242424'}
    strokeWidth={1.5}
  />
);

export const PlusFilledIcon: FC<imageProps> = ({ color, size }) => (
  <svg
    width={size || '28'}
    height={size || '28'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89125C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89125C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7176 20.1088 20.1088C18.7175 21.5001 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5001 3.89124 20.1088C2.5 18.7176 2.5 16.4783 2.5 12Z"
      fill="#6B83E7"
      stroke="#6B83E7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V16M16 12.0001H8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AudioWaveAnimation: FC<imageProps> = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
    <path
      fill={color}
      d="M0,96L0,288L36.9,288L36.9,160L73.8,160L73.8,64L110.8,64L110.8,128L147.7,128L147.7,0L184.6,0L184.6,256L221.5,256L221.5,288L258.5,288L258.5,256L295.4,256L295.4,64L332.3,64L332.3,224L369.2,224L369.2,32L406.2,32L406.2,128L443.1,128L443.1,96L480,96L480,96L516.9,96L516.9,224L553.8,224L553.8,32L590.8,32L590.8,160L627.7,160L627.7,32L664.6,32L664.6,64L701.5,64L701.5,0L738.5,0L738.5,64L775.4,64L775.4,224L812.3,224L812.3,256L849.2,256L849.2,160L886.2,160L886.2,224L923.1,224L923.1,96L960,96L960,0L996.9,0L996.9,288L1033.8,288L1033.8,192L1070.8,192L1070.8,64L1107.7,64L1107.7,128L1144.6,128L1144.6,288L1181.5,288L1181.5,96L1218.5,96L1218.5,224L1255.4,224L1255.4,288L1292.3,288L1292.3,288L1329.2,288L1329.2,32L1366.2,32L1366.2,32L1403.1,32L1403.1,96L1440,96L1440,320L1403.1,320L1403.1,320L1366.2,320L1366.2,320L1329.2,320L1329.2,320L1292.3,320L1292.3,320L1255.4,320L1255.4,320L1218.5,320L1218.5,320L1181.5,320L1181.5,320L1144.6,320L1144.6,320L1107.7,320L1107.7,320L1070.8,320L1070.8,320L1033.8,320L1033.8,320L996.9,320L996.9,320L960,320L960,320L923.1,320L923.1,320L886.2,320L886.2,320L849.2,320L849.2,320L812.3,320L812.3,320L775.4,320L775.4,320L738.5,320L738.5,320L701.5,320L701.5,320L664.6,320L664.6,320L627.7,320L627.7,320L590.8,320L590.8,320L553.8,320L553.8,320L516.9,320L516.9,320L480,320L480,320L443.1,320L443.1,320L406.2,320L406.2,320L369.2,320L369.2,320L332.3,320L332.3,320L295.4,320L295.4,320L258.5,320L258.5,320L221.5,320L221.5,320L184.6,320L184.6,320L147.7,320L147.7,320L110.8,320L110.8,320L73.8,320L73.8,320L36.9,320L36.9,320L0,320L0,320Z"
    ></path>
  </svg>
);

export const TextCursorIcon: FC<imageProps> = ({ color }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.50016 1.375H3.66683C2.80241 1.375 2.37066 1.375 2.10208 1.64358C1.8335 1.91217 1.8335 2.34392 1.8335 3.20833V3.64375M5.50016 1.375H7.3335C8.19791 1.375 8.62966 1.375 8.89825 1.64358C9.16683 1.91217 9.16683 2.34392 9.16683 3.20833V3.64375M5.50016 1.375V3.66667M5.50016 9.625V5.5M3.2085 9.625H7.79183"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlayerPlayIcon: FC<imageProps> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-8 h-8"
    color="#5579F2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
    />
  </svg>
);

export const PlayerPauseIcon: FC<imageProps> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-8 h-8"
    color="#5579F2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 5.25v13.5m-7.5-13.5v13.5"
    />
  </svg>
);

export const SuccessIcon: FC<imageProps> = ({ color }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 30H31M17 36H24M38 4H10C9.46957 4 8.96086 4.21071 8.58579 4.58579C8.21071 4.96086 8 5.46957 8 6V42C8 42.5304 8.21071 43.0391 8.58579 43.4142C8.96086 43.7893 9.46957 44 10 44H38C38.5304 44 39.0391 43.7893 39.4142 43.4142C39.7893 43.0391 40 42.5304 40 42V6C40 5.46957 39.7893 4.96086 39.4142 4.58579C39.0391 4.21071 38.5304 4 38 4Z"
      stroke="#009881"
      stroke-opacity="0.89"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30 13L22 21L18 17"
      stroke="#009881"
      stroke-opacity="0.89"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ErrorIcon: FC<imageProps> = ({ color, size }) => (
  <svg
    width={size ?? '36'}
    height={size ?? '36'}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38 4H10C9.46957 4 8.96086 4.21071 8.58579 4.58579C8.21071 4.96086 8 5.46957 8 6V42C8 42.5304 8.21071 43.0391 8.58579 43.4142C8.96086 43.7893 9.46957 44 10 44H38C38.5304 44 39.0391 43.7893 39.4142 43.4142C39.7893 43.0391 40 42.5304 40 42V6C40 5.46957 39.7893 4.96086 39.4142 4.58579C39.0391 4.21071 38.5304 4 38 4Z"
      stroke="#F95572"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8534 17.0267L24.0001 22.1734L29.1201 17.0534C29.2331 16.933 29.3694 16.8367 29.5206 16.7703C29.6718 16.7039 29.8349 16.6686 30.0001 16.6667C30.3537 16.6667 30.6928 16.8072 30.9429 17.0573C31.1929 17.3073 31.3334 17.6465 31.3334 18.0001C31.3365 18.1636 31.3062 18.3259 31.2443 18.4773C31.1824 18.6286 31.0902 18.7657 30.9734 18.8801L25.7867 24.0001L30.9734 29.1867C31.1931 29.4017 31.322 29.6929 31.3334 30.0001C31.3334 30.3537 31.1929 30.6928 30.9429 30.9429C30.6928 31.1929 30.3537 31.3334 30.0001 31.3334C29.8301 31.3405 29.6606 31.3121 29.5022 31.2501C29.3438 31.1882 29.2001 31.0939 29.0801 30.9734L24.0001 25.8267L18.8667 30.9601C18.7541 31.0764 18.6195 31.1693 18.4707 31.2334C18.322 31.2975 18.162 31.3315 18.0001 31.3334C17.6464 31.3334 17.3073 31.1929 17.0572 30.9429C16.8072 30.6928 16.6667 30.3537 16.6667 30.0001C16.6636 29.8366 16.6939 29.6742 16.7558 29.5229C16.8178 29.3716 16.9099 29.2345 17.0267 29.1201L22.2134 24.0001L17.0267 18.8134C16.807 18.5984 16.6781 18.3073 16.6667 18.0001C16.6667 17.6465 16.8072 17.3073 17.0572 17.0573C17.3073 16.8072 17.6464 16.6667 18.0001 16.6667C18.3201 16.6707 18.6267 16.8001 18.8534 17.0267Z"
      fill="#F95572"
    />
  </svg>
);

export const AddMediaIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 21H3.6C3.44087 21 3.28826 20.9368 3.17574 20.8243C3.06321 20.7117 3 20.5591 3 20.4V3.6C3 3.44087 3.06321 3.28826 3.17574 3.17574C3.28826 3.06321 3.44087 3 3.6 3H20.4C20.5591 3 20.7117 3.06321 20.8243 3.17574C20.9368 3.28826 21 3.44087 21 3.6V13M16 19H19M19 19H22M19 19V16M19 19V22"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.898 8.51283C9.80681 8.46065 9.70352 8.43333 9.59846 8.4336C9.4934 8.43387 9.39025 8.46172 9.29933 8.51436C9.20841 8.56701 9.13291 8.64261 9.08038 8.7336C9.02785 8.82458 9.00013 8.92777 9 9.03283V14.9658C8.99996 15.071 9.02755 15.1743 9.08001 15.2654C9.13247 15.3565 9.20795 15.4323 9.2989 15.485C9.38985 15.5378 9.49307 15.5657 9.59821 15.5661C9.70336 15.5664 9.80674 15.5391 9.898 15.4868L15.088 12.5208C15.1799 12.4684 15.2562 12.3925 15.3093 12.301C15.3624 12.2095 15.3904 12.1056 15.3904 11.9998C15.3904 11.894 15.3624 11.7901 15.3093 11.6986C15.2562 11.6071 15.1799 11.5313 15.088 11.4788L9.898 8.51283Z"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ExportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9652_4201)">
      <path
        d="M6 13.61H13.61V6H24V14.38H26V6C26 5.46957 25.7893 4.96086 25.4142 4.58579C25.0391 4.21071 24.5304 4 24 4H10.87L4 10.87V30C4 30.5304 4.21071 31.0391 4.58579 31.4142C4.96086 31.7893 5.46957 32 6 32H24C24.5304 32 25.0391 31.7893 25.4142 31.4142C25.7893 31.0391 26 30.5304 26 30H6V13.61ZM6 11.69L11.69 6H12V12H6V11.69Z"
        fill="#5579F2"
      />
      <path
        d="M28.32 16.3498C28.1287 16.186 27.8826 16.1004 27.6309 16.1101C27.3793 16.1198 27.1405 16.2242 26.9624 16.4023C26.7843 16.5804 26.68 16.8191 26.6703 17.0708C26.6606 17.3225 26.7462 17.5685 26.91 17.7598L30.16 20.9998H18C17.7348 20.9998 17.4804 21.1052 17.2929 21.2927C17.1054 21.4803 17 21.7346 17 21.9998C17 22.265 17.1054 22.5194 17.2929 22.7069C17.4804 22.8945 17.7348 22.9998 18 22.9998H30.19L26.91 26.2798C26.8053 26.3695 26.7203 26.4798 26.6603 26.6039C26.6003 26.7279 26.5665 26.8631 26.5612 27.0008C26.5559 27.1385 26.5791 27.2758 26.6294 27.4042C26.6796 27.5325 26.7559 27.649 26.8533 27.7465C26.9508 27.8439 27.0674 27.9202 27.1957 27.9705C27.324 28.0207 27.4613 28.044 27.5991 28.0386C27.7368 28.0333 27.8719 27.9996 27.996 27.9396C28.12 27.8795 28.2304 27.7945 28.32 27.6898L34 21.9998L28.32 16.3498Z"
        fill="#5579F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_9652_4201">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ManageProfileIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12C2 7.757 2 5.636 3.464 4.318C4.93 3 7.286 3 12 3C16.714 3 19.071 3 20.535 4.318C21.999 5.636 22 7.758 22 12C22 16.242 22 18.364 20.535 19.682C19.072 21 16.714 21 12 21C7.286 21 4.929 21 3.464 19.682C1.999 18.364 2 16.242 2 12Z"
      stroke="#5579F2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 16H10M14 8H18M14 12H18M14 16H18M8.4 8H7.6C6.846 8 6.469 8 6.234 8.234C6 8.47 6 8.846 6 9.6V10.4C6 11.154 6 11.531 6.234 11.766C6.47 12 6.846 12 7.6 12H8.4C9.154 12 9.531 12 9.766 11.766C10 11.53 10 11.154 10 10.4V9.6C10 8.846 10 8.469 9.766 8.234C9.53 8 9.154 8 8.4 8Z"
      stroke="#5579F2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SaveIcon = ({ color = '#fff' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 21V19C16 17.114 16 16.172 15.414 15.586C14.828 15 13.886 15 12 15H11C9.114 15 8.172 15 7.586 15.586C7 16.172 7 17.114 7 19V21"
      stroke={color}
    />
    <path d="M7 8H12" stroke={color} stroke-linecap="round" />
    <path
      d="M3 9C3 6.172 3 4.757 3.879 3.879C4.757 3 6.172 3 9 3H16.172C16.58 3 16.785 3 16.968 3.076C17.152 3.152 17.297 3.296 17.586 3.586L20.414 6.414C20.704 6.704 20.848 6.848 20.924 7.032C21 7.215 21 7.42 21 7.828V15C21 17.828 21 19.243 20.121 20.121C19.243 21 17.828 21 15 21H9C6.172 21 4.757 21 3.879 20.121C3 19.243 3 17.828 3 15V9Z"
      stroke={color}
    />
  </svg>
);

export const Forward15SecondIcon = () => (
  <svg
    width="16"
    height="23"
    viewBox="0 0 16 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.06712 3.18299C6.12517 3.24103 6.17122 3.30994 6.20264 3.38578C6.23406 3.46162 6.25023 3.5429 6.25023 3.62499C6.25023 3.70708 6.23406 3.78837 6.20264 3.86421C6.17122 3.94005 6.12517 4.00896 6.06712 4.06699L3.63412 6.49999H8.37512C11.7576 6.49999 14.5001 9.24249 14.5001 12.625V12.875C14.5001 13.0408 14.4343 13.1997 14.3171 13.3169C14.1998 13.4341 14.0409 13.5 13.8751 13.5C13.7094 13.5 13.5504 13.4341 13.4332 13.3169C13.316 13.1997 13.2501 13.0408 13.2501 12.875V12.625C13.2501 11.9848 13.124 11.3509 12.879 10.7594C12.634 10.168 12.2749 9.63053 11.8223 9.17785C11.3696 8.72516 10.8322 8.36607 10.2407 8.12108C9.64924 7.87609 9.01531 7.74999 8.37512 7.74999H3.63412L6.06712 10.183C6.18434 10.3002 6.2502 10.4592 6.2502 10.625C6.2502 10.7908 6.18434 10.9498 6.06712 11.067C5.94989 11.1842 5.7909 11.2501 5.62512 11.2501C5.45933 11.2501 5.30034 11.1842 5.18312 11.067L1.68312 7.56699C1.62506 7.50896 1.57901 7.44005 1.54759 7.36421C1.51617 7.28837 1.5 7.20708 1.5 7.12499C1.5 7.0429 1.51617 6.96162 1.54759 6.88578C1.57901 6.80994 1.62506 6.74103 1.68312 6.68299L5.18312 3.18299C5.24116 3.12494 5.31006 3.07889 5.3859 3.04747C5.46174 3.01605 5.54303 2.99988 5.62512 2.99988C5.70721 2.99988 5.78849 3.01605 5.86433 3.04747C5.94017 3.07889 6.00908 3.12494 6.06712 3.18299Z"
      fill="#242424"
    />
    <path
      d="M3.728 20V19.32H5.248V15L5.664 15.048L4.016 16.096L3.672 15.488L5.456 14.36H6.032V19.32H7.432V20H3.728ZM10.2529 20.072C10.0022 20.072 9.76221 20.048 9.53288 20C9.30888 19.9467 9.09554 19.8693 8.89288 19.768C8.69554 19.6613 8.51954 19.5333 8.36488 19.384L8.66888 18.768C8.90888 18.9867 9.15688 19.144 9.41288 19.24C9.67421 19.336 9.95154 19.384 10.2449 19.384C10.6289 19.384 10.9275 19.288 11.1409 19.096C11.3542 18.8987 11.4609 18.6213 11.4609 18.264C11.4609 17.912 11.3595 17.632 11.1569 17.424C10.9595 17.216 10.6822 17.112 10.3249 17.112C10.0849 17.112 9.86888 17.16 9.67688 17.256C9.48488 17.3467 9.30621 17.5013 9.14088 17.72H8.53288V14.36H11.9409V15.04H9.25288V17.064H9.21288C9.34088 16.8773 9.51421 16.728 9.73288 16.616C9.95154 16.4987 10.1969 16.44 10.4689 16.44C10.8262 16.44 11.1355 16.5173 11.3969 16.672C11.6635 16.8213 11.8662 17.0293 12.0049 17.296C12.1489 17.5627 12.2209 17.8747 12.2209 18.232C12.2209 18.6107 12.1409 18.9387 11.9809 19.216C11.8209 19.4933 11.5915 19.7067 11.2929 19.856C10.9995 20 10.6529 20.072 10.2529 20.072Z"
      fill="#242424"
    />
  </svg>
);

export const Backward15SecondIcon = () => (
  <svg
    width="16"
    height="23"
    viewBox="0 0 16 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.93288 3.18299C9.87483 3.24103 9.82878 3.30994 9.79736 3.38578C9.76594 3.46162 9.74977 3.5429 9.74977 3.62499C9.74977 3.70708 9.76594 3.78837 9.79736 3.86421C9.82878 3.94005 9.87483 4.00896 9.93288 4.06699L12.3659 6.49999H7.62488C4.24238 6.49999 1.49988 9.24249 1.49988 12.625V12.875C1.49988 13.0408 1.56573 13.1997 1.68294 13.3169C1.80015 13.4341 1.95912 13.5 2.12488 13.5C2.29064 13.5 2.44962 13.4341 2.56683 13.3169C2.68404 13.1997 2.74988 13.0408 2.74988 12.875V12.625C2.74988 11.9848 2.87598 11.3509 3.12097 10.7594C3.36596 10.168 3.72505 9.63053 4.17774 9.17785C4.63042 8.72516 5.16784 8.36607 5.7593 8.12108C6.35076 7.87609 6.98469 7.74999 7.62488 7.74999H12.3659L9.93288 10.183C9.81566 10.3002 9.7498 10.4592 9.7498 10.625C9.7498 10.7908 9.81566 10.9498 9.93288 11.067C10.0501 11.1842 10.2091 11.2501 10.3749 11.2501C10.5407 11.2501 10.6997 11.1842 10.8169 11.067L14.3169 7.56699C14.3749 7.50896 14.421 7.44005 14.4524 7.36421C14.4838 7.28837 14.5 7.20708 14.5 7.12499C14.5 7.0429 14.4838 6.96162 14.4524 6.88578C14.421 6.80994 14.3749 6.74103 14.3169 6.68299L10.8169 3.18299C10.7588 3.12494 10.6899 3.07889 10.6141 3.04747C10.5383 3.01605 10.457 2.99988 10.3749 2.99988C10.2928 2.99988 10.2115 3.01605 10.1357 3.04747C10.0598 3.07889 9.99092 3.12494 9.93288 3.18299Z"
      fill="#242424"
    />
    <path
      d="M3.728 20V19.32H5.248V15L5.664 15.048L4.016 16.096L3.672 15.488L5.456 14.36H6.032V19.32H7.432V20H3.728ZM10.2529 20.072C10.0022 20.072 9.76221 20.048 9.53288 20C9.30888 19.9467 9.09554 19.8693 8.89288 19.768C8.69554 19.6613 8.51954 19.5333 8.36488 19.384L8.66888 18.768C8.90888 18.9867 9.15688 19.144 9.41288 19.24C9.67421 19.336 9.95154 19.384 10.2449 19.384C10.6289 19.384 10.9275 19.288 11.1409 19.096C11.3542 18.8987 11.4609 18.6213 11.4609 18.264C11.4609 17.912 11.3595 17.632 11.1569 17.424C10.9595 17.216 10.6822 17.112 10.3249 17.112C10.0849 17.112 9.86888 17.16 9.67688 17.256C9.48488 17.3467 9.30621 17.5013 9.14088 17.72H8.53288V14.36H11.9409V15.04H9.25288V17.064H9.21288C9.34088 16.8773 9.51421 16.728 9.73288 16.616C9.95154 16.4987 10.1969 16.44 10.4689 16.44C10.8262 16.44 11.1355 16.5173 11.3969 16.672C11.6635 16.8213 11.8662 17.0293 12.0049 17.296C12.1489 17.5627 12.2209 17.8747 12.2209 18.232C12.2209 18.6107 12.1409 18.9387 11.9809 19.216C11.8209 19.4933 11.5915 19.7067 11.2929 19.856C10.9995 20 10.6529 20.072 10.2529 20.072Z"
      fill="#242424"
    />
  </svg>
);

export const RestoreIcon = ({ color }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2508 2.99976C12.0473 2.96539 10.8491 3.17277 9.72718 3.60961C8.60524 4.04645 7.58233 4.70389 6.71895 5.54302C5.85558 6.38216 5.16928 7.38594 4.70067 8.49498C4.23206 9.60402 3.99066 10.7958 3.99075 11.9998H2.20075C1.75075 11.9998 1.53075 12.5398 1.85075 12.8498L4.64075 15.6498C4.84075 15.8498 5.15075 15.8498 5.35075 15.6498L8.14075 12.8498C8.46075 12.5398 8.23075 11.9998 7.79075 11.9998H5.99075C5.99075 8.09976 9.17075 4.94976 13.0908 4.99976C16.8108 5.04976 19.9408 8.17976 19.9908 11.8998C20.0408 15.8098 16.8908 18.9998 12.9908 18.9998C11.3808 18.9998 9.89075 18.4498 8.71075 17.5198C8.51922 17.3689 8.2789 17.2937 8.03552 17.3084C7.79214 17.3232 7.56267 17.4269 7.39075 17.5998C6.97075 18.0298 7.00075 18.7298 7.47075 19.0998C9.04593 20.3336 10.9899 21.0027 12.9908 20.9998C18.0408 20.9998 22.1308 16.8298 21.9908 11.7398C21.8608 7.04976 17.9408 3.12976 13.2508 2.99976ZM12.7408 7.99976C12.3308 7.99976 11.9908 8.33976 11.9908 8.74976V12.4298C11.9908 12.7798 12.1808 13.1098 12.4808 13.2898L15.6008 15.1398C15.9608 15.3498 16.4208 15.2298 16.6308 14.8798C16.8408 14.5198 16.7208 14.0598 16.3708 13.8498L13.4908 12.1398V8.73976C13.4908 8.33976 13.1608 7.99976 12.7408 7.99976Z"
      fill={color}
    />
  </svg>
);

export const ArchiveIcon = ({ color, width, height }: any) => (
  <svg
    width={width ?? '18'}
    height={height ?? '18'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 11.5H13.5M20 8V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V8M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8H21Z"
      stroke={color ?? '#242424'}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const MoveToIcon = ({ size = 16 }: { size?: number }) => (
  <HugeiconsIcon icon={MoveToHugeIcon} size={size} strokeWidth={1.5} />
);

export const MoveIcon = ({ size = 16 }: { size?: number }) => (
  <HugeiconsIcon icon={MoveHugeIcon} size={size} strokeWidth={1.5} />
);
